/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'

// New Enhanced Dashboard with lazy loading and on-demand data fetching
import DashboardPageEnhanced from './DashboardPageEnhanced'

// Old dashboard (kept for reference/rollback)
// import DashboardPage from './DashBoardPage'

const AdminDashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPageEnhanced />
    </>
  )
}

export {AdminDashboardWrapper}
